import { useToastsHook, useTranslation } from '@bcba/react-hooks';
import { Modal, Flex, Text, AlertOctagonIcon } from '@agrotoken-tech/ui';
import { useMutation } from '@tanstack/react-query';
import { creditorRejectCropPledge } from '../../../../services/crop-pledge';
import { useCropPledgeContext } from '../context/CropPledgeContext';
import { useParams } from 'react-router-dom';

interface RejectCropPledgeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RejectCropPledgeModal = ({
  isOpen,
  onClose,
}: RejectCropPledgeModalProps) => {
  const { t } = useTranslation();
  const params = useParams();
  const cropPledgeUuid = params['uuid'] || '';
  const { showSuccessToast } = useToastsHook();

  const { refetchCropPledgeStatus } = useCropPledgeContext();

  const {
    mutate: onCreditorRejectCropPledge,
    isPending: isLoadingCreditorRejection,
  } = useMutation({
    mutationFn: () => creditorRejectCropPledge(cropPledgeUuid),
    onSuccess: () => {
      refetchCropPledgeStatus();
      showSuccessToast({ title: t('cropPledge.reject.toast.success') });
      onClose();
    },
  });

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      title={t('cropPledge.actions.reject.modal.title')}
      isLoadingConfirmBtn={isLoadingCreditorRejection}
      labelBtnConfirm={t('cropPledge.actions.reject.modal.confirmLabel')}
      variantBtnConfirm="primary"
      labelBtnClose={t('common.cancel')}
      iconVariant="destructive"
      icon={AlertOctagonIcon}
      onClickConfirm={onCreditorRejectCropPledge}
    >
      <Flex>
        <Text>{t('cropPledge.actions.reject.modal.text')}</Text>
      </Flex>
    </Modal>
  );
};
